import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 30,
      gcTime: 5 * 60 * 1000,
      retry: 1,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 10000),
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      refetchOnMount: false,
      structuralSharing: true,
    },
    mutations: {
      retry: 1,
    },
  },
});

export const queryKeys = {
  dashboard: {
    all: ["dashboard"] as const,
    overview: (profileId?: string) =>
      ["dashboard", "overview", profileId] as const,
  },

  classes: {
    all: ["classes"] as const,
    lists: () => ["classes", "list"] as const,
    list: (profileId?: string) => ["classes", "list", profileId] as const,
    detail: (id: string) => ["classes", "detail", id] as const,
  },

  students: {
    all: ["students"] as const,
    lists: () => ["students", "list"] as const,
    list: (profileId?: string) => ["students", "list", profileId] as const,
    detail: (id: string) => ["students", "detail", id] as const,
  },

  activities: {
    all: ["activities"] as const,
    lists: () => ["activities", "list"] as const,
    list: (profileId?: string) => ["activities", "list", profileId] as const,
    detail: (id: string) => ["activities", "detail", id] as const,
  },

  materials: {
    all: ["materials"] as const,
    lists: () => ["materials", "list"] as const,
    list: (profileId?: string) => ["materials", "list", profileId] as const,
    detail: (id: string) => ["materials", "detail", id] as const,
  },

  enrollments: {
    all: ["enrollments"] as const,
    lists: () => ["enrollments", "list"] as const,
    list: (profileId?: string) => ["enrollments", "list", profileId] as const,
  },

  grades: {
    all: ["grades"] as const,
    list: (profileId?: string) => ["grades", "list", profileId] as const,
    byActivity: (activityId: string) =>
      ["grades", "activity", activityId] as const,
    byStudent: (studentId: string) => ["grades", "student", studentId] as const,
  },

  reports: {
    all: ["reports"] as const,
    lists: () => ["reports", "list"] as const,
    list: (profileId?: string) => ["reports", "list", profileId] as const,
  },

  schoolProfiles: {
    all: ["schoolProfiles"] as const,
    lists: () => ["schoolProfiles", "list"] as const,
  },

  notifications: {
    all: ["notifications"] as const,
    list: (profileId?: string) => ["notifications", "list", profileId] as const,
  },

  messages: {
    all: ["messages"] as const,
    list: (profileId?: string) => ["messages", "list", profileId] as const,
    byChat: (chatId: string) => ["messages", "chat", chatId] as const,
  },
};
